import {Component} from "react";
import React from "react";


export class AgencyFormFieldError extends Component {

    render(){
        return <small className="text-danger">{this._errorMessage()}</small>
    }

    _errorMessage(){
        let errors = this.props.errors;
        let fieldName = this.props.fieldName;
        if (fieldName in errors) {
            return this._messageFrom(errors, fieldName);
        } else {
            return "";
        }
    }

    _messageFrom(errors, fieldName) {
        let fieldErrors = errors[fieldName];
        let messages = fieldErrors.map((each) => each.message);
        return messages.join(', ')
    }
}